// utils/common/fingerprintHint.ts

// Stable-ish hint: platform + browser family + coarse HW buckets.
// Avoid volatile fields (screen size, DPR, timezone, lang).

function uaFamily(): string {
  const ua = (navigator.userAgent || "").toLowerCase();
  if (ua.includes("edg/")) return "edge";
  if (ua.includes("firefox/")) return "firefox";
  // Chrome before Safari (Chrome UA also contains 'Safari')
  if (ua.includes("chrome/")) return "chrome";
  if (ua.includes("safari/")) return "safari";
  return "other";
}

export async function getFingerprintHintHash(): Promise<string> {
  try {
    const anyNav: any = navigator as any;
    const plat = (anyNav.userAgentData?.platform || navigator.platform || "unknown").toLowerCase();
    const fam = uaFamily();
    const cores = (navigator as any).hardwareConcurrency || 0;
    const mem = (navigator as any).deviceMemory || 0;

    // coarse buckets to reduce churn
    const hcBucket = cores >= 8 ? "8+" : cores >= 4 ? "4-7" : cores ? "1-3" : "u";
    const memBucket = mem >= 8 ? "8+" : mem >= 4 ? "4-7" : mem ? "1-3" : "u";

    const raw = `${plat}|${fam}|hc:${hcBucket}|mem:${memBucket}`;
    const enc = new TextEncoder().encode(raw);
    const digest = await crypto.subtle.digest("SHA-256", enc);
    const b64 = btoa(String.fromCharCode(...new Uint8Array(digest)))
      .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
    return b64; // base64url
  } catch {
    return "unknown";
  }
}
